const cardHolders = [
  { name: "HMO", abbr: "wls" },
  { name: "Membership", abbr: "mbs" },
  { name: "Contract", abbr: "ctr" },
  { name: "PhilHealth", abbr: "ph" },
];

export default cardHolders;
